export const SEMEADOR_ADUBADOR_DUPLO_2 = {
    Codigo: 16,
    Nome: 'Semeador Adubador Duplo',
    Capa: null, 
    Home: true,
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Semeador_Adubador_Duplo_2/semeador-adubador_1.png"
        }
        , {
            Url: "assets/IPB/Produtos/Semeador_Adubador_Duplo_2/semeador-adubador_2.png"
        }
        , {
            Url: "assets/IPB/Produtos/Semeador_Adubador_Duplo_2/semeador-adubador_3.png"
        }
        , {
            Url: "assets/IPB/Produtos/Semeador_Adubador_Duplo_2/semeador-adubador_4.png"
        }
        , {
            Url: "assets/IPB/Produtos/Semeador_Adubador_Duplo_2/semeador-adubador_5.jpeg"
        }
    ],
    Detalhes: [
        `Distribuidor duplo de uréia, adubo, semente e calcário`,
        `Prato pás e defletor em INOX`,
        `Distribuição homogênea`,
        `Transmissão INPEL`,
        `Grade protetora em plástico injetado e chapéu chinês`,
        `Acionamento por cabo, alavanca ou hidráulico`
    ],
    Modelos: [
        { Modelo: `GIR-1300`, Detalhes:	`Alavanca` },
        { Modelo: `GIR-1300`, Detalhes:	`Cabo` },
        { Modelo: `GIR-1300`, Detalhes:	`Hidraulico` },

        { Modelo: `GIR-1700`, Detalhes:	`Alavanca` },
        { Modelo: `GIR-1700`, Detalhes:	`Cabo` },
        { Modelo: `GIR-1700`, Detalhes:	`Hidraulico` },
    ]
}